import $api from "http";
import $apiJSON from "http/apiJSON";


export async function getOrder( data) {
  return $api.get(`/outbox-orders/`,data);
}

export async function getOrderForRegist( data) {
  return $api.get(`/ordersforregist/`,data);
}
export async function getOrderInbox( data) {
  return $api.get(`/inbox-orders/`,data);
}
export async function getOrderHistory( data) {
  return $api.get(`/history-orders/`,data);
}

export async function getOrderData(id , data) {
  return $api.get(`/order/${id}/`,data);
}

export async function createOrder(file,order_file,user_id,file_2 ) {
  return $api.post("/order/",{file,order_file,user_id,file_2 });
}

export async function registerOrder(user_id , order_date,order_number,file ) {
  return $api.post("/register-order/",{ user_id , order_date,order_number,file });
}

export async function RequestReportOrder(data) {
  return $apiJSON.post("/order-report/",data);
}


export async function patchOrder(id, data) {
  return $apiJSON.patch(`/order/${id}/`, data)
}
export async function patchOrderFormData(id, data) {
  return $api.patch(`/order/${id}/`, data)
}


export async function getPositionData( data) {
  return $api.get(`/position/`,data);
}
export async function getTopPositionData(data) {
  return $api.get(`/position-empl/`,data);
}


export async function getPositionEmpData(id , data) {
  return $api.get(`/posempl/${id}/`,data);
}

export async function postChatsOrder(id , data) {
  return $apiJSON.post(`/order-chat/${id}/`,data);
}